import { NotFoundError } from '@ember-data/adapter/error';

export function cacheKeyFor(modelName, id) {
  return modelName ? `${modelName}_${id ? id : 'query'}` : 'default-store';
}

export function fetchWithCache(modelName, fastboot, fetchFn, { serialize, deserialize, id } = {}) {
  const cacheKey = cacheKeyFor(modelName, id);
  const { isSsr, isInitialRoute, shoebox, useCache } = fastboot;

  if (isSsr) {
    const results = fetchFn().catch(e => {
      shoebox.put(cacheKey, null);
      throw e;
    });
    results.then(result => {
      let serialized;
      if (serialize) {
        const ids = [];
        const data = [];
        serialized = { ids, data };
        result.forEach(result => {
          ids.push(result.id);
          data.push(serialize ? serialize(result) : result);
        });
      } else {
        serialized = result;
      }
      // must deep-copy for clean serialization.
      shoebox.put(cacheKey, JSON.parse(JSON.stringify(serialized)));
    }).catch(() => {});
    return results;
  }

  let result;
  if (useCache && isInitialRoute) {
    result = shoebox.retrieve(cacheKey);
  }
  if (!result && result !== null) {
    result = fetchFn();
  } else if (result) {
    // must deep-copy for clean serialization.
    result = JSON.parse(JSON.stringify(result));
    if (deserialize) {
      result = deserialize(result);
    }
  } else {
    result = id ? Promise.reject(new NotFoundError()) : [];
  }
  return result;
}
